module.exports = "/_next/static/images/OrchestrateAndOptimize-a5831ba4338090e88258cbcccb591f71.webp";